var map = {
	"./1_down@2x.png": 970,
	"./1_up@2x.png": 971,
	"./2_down@2x.png": 972,
	"./2_up@2x.png": 973,
	"./3_down@2x.png": 974,
	"./3_up@2x.png": 975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4464;